import { Fragment, useContext } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Links from './Links';
import { routes } from '../../utils/routes';
import DisclosurePanel from './DisclosurePanel';
import BreadCrumb from '../BreadCrumb';
import AuthContext from '../../context/AuthContext';
import { Link, useLocation } from "react-router-dom";
import { TbCircleLetterM } from "react-icons/tb"
import { WarningBorder } from '../Alerts';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Navbar({brandText, setEnablePaymentCheckout}) {
  const { signOut, userInfo, subscription } = useContext(AuthContext);
  const userNavigation = [
    { name: userInfo.username, path: '#' },
    { name: userInfo.email, path: '#' },
    { name: 'Settings', path: '/dashboard/settings' },
    { name: 'Sign out', path: '#' },
  ]
  const userProfileName = userInfo.username || ""
  return (
    <>
      <div className="min-h-full">
        <Disclosure as="nav" className="bg-gray-800">
          {({ open }) => (
            <>
              <div className="mx-auto max-w-[80em] px-4 sm:px-6 lg:px-8">
                <div className="flex h-16 items-center justify-between">
                  <div className="flex items-center">
                    <div className="flex-shrink-0">
                      {/* <img
                        className="h-8 w-8"
                        src="/logo.png"
                        alt="Your Company"
                      /> */}
                      <TbCircleLetterM className=' text-[#6467F1] text-5xl' />
                    </div>
                    <Links setEnablePaymentCheckout={setEnablePaymentCheckout} routes={routes}/>
                  </div>
                  <div className="hidden md:block">
                    <div className="ml-4 flex items-center md:ml-6">
                      <button
                        type="button"
                        className="relative rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
                      >
                        <span className="absolute -inset-1.5" />
                        <span className="sr-only">View notifications</span>
                        <BellIcon className="h-6 w-6" aria-hidden="true" />
                      </button>

                      {subscription.subscription_type == "Free Trial" && subscription.status === "Active" && <>
                        <p className=' px-2 text-gray-300'>{subscription.trialEndDate || ""}</p>
                        <button
                        onClick={()=> setEnablePaymentCheckout(true)}
                          type="button"
                          className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-gray-300 shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                          Upgrade now
                        </button>
                      </>}
                      {/* Profile dropdown */}
                      <Menu as="div" className="relative ml-3">
                        <div>
                          <Menu.Button className="relative flex max-w-xs items-center rounded-full bg-gray-800 text-sm text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                            <span className="absolute -inset-1.5" />
                            <span className="sr-only">Open user menu</span>

                            {userInfo.profileUrl ? <img className="h-8 w-8 rounded-full" src={userInfo.profileUrl} alt="" /> : <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-500"><span className="text-sm font-medium leading-none text-white">{userProfileName.charAt(0)}</span></span>}
                          </Menu.Button>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            {userNavigation.map((item, index) => (<Link key={index} to={item.path}>
                              <Menu.Item key={item.name}>
                                {({ active }) => (
                                  <p

                                    onClick={()=> (item.name == "Sign out" && signOut())}
                                    className={classNames(
                                      active ? 'bg-gray-100' : '',
                                      'block px-4 py-2 text-sm text-gray-700'
                                    )}
                                  >
                                    {item.name}
                                  </p>
                                )}
                              </Menu.Item>
                            </Link>))}
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    </div>
                  </div>
                  <div className="-mr-2 flex md:hidden">
                    {/* Mobile menu button */}
                    <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md bg-gray-800 p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                      <span className="absolute -inset-0.5" />
                      <span className="sr-only">Open main menu</span>
                      {open ? (
                        <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                      ) : (
                        <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                      )}
                    </Disclosure.Button>
                  </div>
                </div>
              </div>
              <DisclosurePanel routes={routes} userNavigation={userNavigation} user={userInfo}/>
              <BreadCrumb brandText={brandText}/>
            </>
          )}
        </Disclosure>
        {subscription.status === "Expired" &&
         <WarningBorder message={<> Your  plan has been expired.{' '}
                <a href="#" className="font-medium text-yellow-700 underline hover:text-yellow-600">
                  Upgrade your account.
                </a></>}/>}
      </div>
    </>
  )
}
